import type { FieldWrapperInjectedProps } from "@birdwatch/ui/form";
import { useMemo } from "react";
import { Combobox, type ComboboxOption } from "@/components/ui/combobox";
import { useGetGlobalOffice } from "@/features/office/_api/use-global-office";

type CategorySelectProps = FieldWrapperInjectedProps & {
  className?: string;
  value: string | null;
  onChange: (value: string | null) => void;
  defaultOpen?: boolean;
  onOpenChange?: (open: boolean) => void;
  modal?: boolean;
  disabled?: boolean;
  "data-test"?: string;
};

export default function CategorySelect({
  className,
  value,
  onChange,
  defaultOpen = false,
  onOpenChange,
  modal = true,
  disabled,
  ...props
}: CategorySelectProps) {
  const { data: globalValues } = useGetGlobalOffice();
  const categories = globalValues?.categories || [];

  const options = useMemo<ComboboxOption[]>(
    () =>
      categories.map((category) => ({
        value: category.id,
        label: category.title,
      })),
    [categories],
  );

  return (
    <Combobox
      {...props}
      value={value}
      onChange={onChange}
      options={options}
      placeholder="Select category"
      searchPlaceholder="Search category..."
      emptyText="No category found."
      defaultOpen={defaultOpen}
      onOpenChange={onOpenChange}
      modal={modal}
      disabled={disabled}
      className={className}
    />
  );
}
